import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Locales } from '@ridango/core/lib/ridango.models';

@Injectable({
    providedIn: 'root'
})
export class LocaleService {
    public menuChangeLanguage = '';
    private readonly localePath = 'assets/settings/locales.json';
    private localeData: Locales;

    constructor(private http: HttpClient) {}

    getLocaleData(): Promise<Locales> {
        return this.http.get<Locales>(this.localePath).toPromise();
    }

    getLocale(): Locales {
        return this.localeData;
    }

    setLocale(locale: Locales): void {
        this.localeData = locale;
    }
}
